import React, { Component } from "react";
import { debounce } from "lodash";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

import { withRequest } from "../../utils/request";
import Modal from "../general/Modal";
import Create from "../Empleados/Solicitudes/Create";
import Edit from "../Empleados/Solicitudes/Edit";
import Loader from "../general/Loader";
import { auth } from "../../utils/auth";
import { apiUrl } from "../../utils/apiUrl";
import Pagination from "../general/Pagination";
import { getLink, toast } from "../../utils/helpers";

class Solicitudes extends Component {
    state = {
        solicitudes: [],
        showCreate: false,
        showEdit: false,
        links: [],
        loading: true,
        solicitud: {},
        filtros: {
            limit: 15,
            estado: 'pendiente',
        },
        filtrosQuery: "?estado=pendiente",
    };
    componentDidMount() {
        this.getSolicitudes();
    }
    getSolicitudes = async (url = null) => {

        let query = Object.keys(this.state.filtros).map((fil) => {
            return `${fil}=${this.state.filtros[fil]}`;
        });

        url = url ? url + "&limit=15" : "solicitudes?" + query.join('&');
        const solicitudes = await this.props.request(url);

        if (solicitudes.data) {
            this.setState({
                solicitudes: solicitudes.data,
                loading: false,
                links: solicitudes.links,
                meta: solicitudes.meta,
            });
        }
    };
    toggleCreateModal = () => {
        this.setState({
            showCreate: !this.state.showCreate,
        });
    };
    toggleEditModal = (solicitud) => {
        this.setState({
            showEdit: !this.state.showEdit,
            solicitud,
        });
    };
    updateSolicitud = async (event, solicitud) => {
        event.preventDefault();
        const token = auth.getToken();

        let data = new FormData();
        data.append("_method", "PATCH");
        data.append("estado", event.target.value);

        const res = await fetch(apiUrl(`solicitudes/${solicitud}`), {
            method: "post",
            body: data,
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.getSolicitudes();
            toast("¡Solicitud actualizada!");
        }
    };
    onFiltroChange = debounce(async (value, filtro) => {
        await this.setState({
            filtros: {
                ...this.state.filtros,
                [filtro]: value,
            },
        });

        let query = Object.keys(this.state.filtros).map((fil) => {
            return `${fil}=${this.state.filtros[fil]}`;
        });

        await this.setState({
            filtrosQuery: "?" + query.join("&"),
        });

        this.getSolicitudes("solicitudes?" + query.join("&"));
    }, 500);
    render() {
        const { loading, solicitudes, solicitud, filtrosQuery } = this.state;
        if (loading) {
            return <Loader />;
        }
        return (
            <div className='container'>
                <div className='page-header'>
                    <h1 className='page-title row'>
                        <span className='col'>Todas las Solicitudes</span>
                        <Link
                            to={getLink(`/imprimir/solicitudes${filtrosQuery}`)}
                            target='_blank'
                            className='au-btn-filter m-r-15'>
                            <i className='zmdi zmdi-print' /> Imprimir
                        </Link>
                        <button
                            className='au-btn au-btn-icon au-btn--green au-btn--small'
                            onClick={this.toggleCreateModal}>
                            <i className='zmdi zmdi-plus' />
                            Nueva Solicitud
                        </button>
                    </h1>
                    <div className='page-controls'>
                        <div className='table-data__tool'>
                            <div className='table-data__tool-left row'>
                                <div className='col'>
                                    <label htmlFor='buscar'>Buscar</label>
                                    <input
                                        onChange={(e) =>
                                            this.onFiltroChange(
                                                e.target.value,
                                                "buscar"
                                            )
                                        }
                                        type='search'
                                        placeholder='Buscar...'
                                        className='form-control'
                                        name='buscar'
                                    />
                                </div>
                                <div className='col-md-2'>
                                    <label htmlFor='desde'>Desde</label>
                                    <input
                                        type='date'
                                        name='desde'
                                        id='desde'
                                        className='form-control'
                                        onChange={(e) =>
                                            this.onFiltroChange(
                                                e.target.value,
                                                "desde"
                                            )
                                        }
                                    />
                                </div>
                                <div className='col-md-2'>
                                    <label htmlFor='hasta'>Hasta</label>
                                    <input
                                        type='date'
                                        name='hasta'
                                        id='hasta'
                                        className='form-control'
                                        onChange={(e) =>
                                            this.onFiltroChange(
                                                e.target.value,
                                                "hasta"
                                            )
                                        }
                                    />
                                </div>
                                <div className='col-md-2'>
                                    <label htmlFor='estado'>Estado</label>
                                    <select
                                        onChange={(e) =>
                                            this.onFiltroChange(
                                                e.target.value,
                                                "estado"
                                            )
                                        }
                                        name='estado'
                                        defaultValue='pendiente'
                                        className='form-control'>
                                        <option value='todo'>Todas</option>
                                        <option value='pendiente'>
                                            Pendientes
                                        </option>
                                        <option value='en-progreso'>
                                            En Progreso
                                        </option>
                                        <option value='completada'>
                                            Completadas
                                        </option>
                                        <option value='cancelada'>
                                            Canceladas
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {!solicitudes.length ? (
                    <div>
                        {!loading && <div>No hay solicitudes creadas.</div>}
                    </div>
                ) : (
                    <div>
                        <div className='card'>
                            <div className='row'>
                                {solicitudes.map((solicitud) => {
                                    let estado = "";
                                    switch (solicitud.estado) {
                                        case "cancelada":
                                            estado = "danger";
                                            break;
                                        case "en-progreso":
                                            estado = "primary";
                                            break;
                                        case "completada":
                                            estado = "success";
                                            break;
                                        default:
                                            estado = "warning";
                                            break;
                                    }
                                    return (
                                        <div
                                            key={solicitud.id}
                                            className={
                                                "col-md-12 au-task__item au-task__item--" +
                                                estado
                                            }>
                                            <div className='au-task__item-inner'>
                                                <div className='row'>
                                                    <div className='col'>
                                                        <div
                                                            style={{
                                                                whiteSpace:
                                                                    "pre-line",
                                                            }}>
                                                            {
                                                                solicitud.descripcion
                                                            }
                                                        </div>
                                                        <div
                                                            style={{
                                                                lineHeight: 1.2,
                                                            }}>
                                                            {solicitud.creador && (
                                                                <small>
                                                                    Creador:{" "}
                                                                    {
                                                                        solicitud.creador
                                                                    }
                                                                </small>
                                                            )}
                                                            <br />
                                                            {solicitud.ultimaActividad && (
                                                                <small>
                                                                    {
                                                                        solicitud.ultimaActividad
                                                                    }
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className='col'>
                                                        <strong>
                                                            {solicitud.vehiculo}
                                                        </strong>
                                                        <div>
                                                            {solicitud.empleado}
                                                        </div>
                                                        <small>
                                                            {dayjs(
                                                                solicitud.fecha
                                                            ).format(
                                                                "DD/MM/YYYY"
                                                            )}
                                                        </small>
                                                    </div>
                                                    <div className='col-md-2'>
                                                        <select
                                                            name='estado'
                                                            className='form-control'
                                                            onChange={(e) =>
                                                                this.updateSolicitud(
                                                                    e,
                                                                    solicitud.id
                                                                )
                                                            }
                                                            defaultValue={
                                                                solicitud.estado
                                                            }>
                                                            <option value='pendiente'>
                                                                Pendiente
                                                            </option>
                                                            <option value='en-progreso'>
                                                                En Progreso
                                                            </option>
                                                            <option value='completada'>
                                                                Completada
                                                            </option>
                                                            <option value='cancelada'>
                                                                Cancelada
                                                            </option>
                                                        </select>
                                                        <div className='text-center'>
                                                            <button
                                                                onClick={() =>
                                                                    this.toggleEditModal(
                                                                        solicitud
                                                                    )
                                                                }
                                                                className='btn'>
                                                                <i className='zmdi zmdi-edit' />{" "}
                                                                Editar
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        {this.state.links && (
                            <Pagination
                                links={this.state.links}
                                meta={this.state.meta}
                                getData={this.getSolicitudes}
                            />
                        )}
                    </div>
                )}
                <Modal
                    show={this.state.showCreate}
                    blank={true}
                    toggle={this.toggleCreateModal}>
                    <Create
                        toggle={this.toggleCreateModal}
                        empleado={{}}
                        getSolicitudes={this.getSolicitudes}
                    />
                </Modal>
                <Modal
                    show={this.state.showEdit}
                    blank={true}
                    toggle={this.toggleEditModal}>
                    <Edit
                        toggle={this.toggleEditModal}
                        empleado={{}}
                        solicitud={solicitud}
                        getSolicitudes={this.getSolicitudes}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRequest(Solicitudes);
